import { TASK_TYPES } from 'features/daily-plan/constants';
import {
  PHONE_TYPE_MAP,
  PHONE_TYPES,
  PHONE_USE_MAP
} from 'UI/components/organisms/PhoneNumbersForm/utils';
import { DEFAULT_COUNTRY_CODE } from 'UI/constants/defaults';
import { ENTITY_PROFILES_ROUTES_MAP, EntityType } from 'UI/constants/entityTypes';

export const getRelatedItem = (taskTypeId, { candidate, jobOrder, sendout }) => {
  const callTasks = new Set([
    TASK_TYPES.closingCall,
    TASK_TYPES.debriefCall,
    TASK_TYPES.preparationCall
  ]);

  const map = {
    [TASK_TYPES.marketCandidate]: {
      id: candidate?.id,
      title: candidate?.personalInformation?.fullName ?? '',
      entityType: EntityType.Candidate
    },
    [TASK_TYPES.recruitJobOrder]: {
      id: jobOrder?.id,
      title: jobOrder?.title ?? '',
      entityType: EntityType.Joborder
    }
  };

  if (callTasks.has(taskTypeId)) {
    map[taskTypeId] = {
      id: sendout?.jobOrder?.id,
      title: sendout?.jobOrder?.title ?? '',
      entityType: EntityType.Joborder
    };
  }

  return map[taskTypeId] ?? null;
};

export const getLinkProps = (id, entityType) => {
  const route = ENTITY_PROFILES_ROUTES_MAP[entityType];
  return {
    target: '_blank',
    type: 'local',
    url: route?.replace(':id', id)
  };
};

export const buildCompanyContactData = entity => {
  return {
    ...entity,
    phones: [
      {
        phone: entity.phone || null,
        extension: null,
        country_code: DEFAULT_COUNTRY_CODE,
        country_code_id: 229,
        use: PHONE_USE_MAP.Business.title,
        type_id: PHONE_TYPE_MAP[1].id,
        type: PHONE_TYPES.Land,
        is_default: true
      }
    ]
  };
};
